import { FilterHandler } from 'app/shared/filter-handler';
import { Model } from './model';

export class SaleOffer extends Model {
  id: number;
  kg: number;
  price_kg: number;
  origin_sale: string;
  date: string;
  status: string;
  status_display: string;
  offer_end_datetime?: string | null;
  client_messages?: Array<any> | [any];
  total_price: number;
  buyer?: any;
  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new SaleOffer(values);
  }
}
export class SaleOfferStatus extends Model {
  value: string;
  display_name: string;

  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new SaleOfferStatus(values);
  }
}
export class SaleOfferFilter extends FilterHandler {
  date: string;
  status: string;
  // offer_end_datetime: Date;
  constructor(values: Object = {}) {
    super();
    if (!this.date) {
      const today = new Date();
      this.date = today.toISOString().substring(0, 10);
    }
    if (!this.status) {
      this.status = 'reserved';
    }

    this.unSerializedRouterParams(values);
  }
}

export class InfoCommercializationAssociation extends Model {
  id: number;
  price_minimun: number;
  sale_time_limit: string;
  association: Array<any> | [any];
  constructor(values: Object = {}) {
    super(values);
  }

  apiMap(values: Object = {}) {
    return new InfoCommercializationAssociation(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/commercialization.ts